let navStyle = {
  all: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "space-around",
    width: "15%",
  },
  mobile: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    position: "fixed",
    bottom: "0",
    background: "white",
    paddingTop: "20px"
  },
  profileBtn: {
    borderRadius: "50%",
    width: "22px",
    height: "22px",
  },
  logoutBtn_newPostBtn: {
    width: "22px",
    height: "22px",
    cursor: "pointer",
  },
};

export default navStyle;
